import BaseService from '../commons/BaseService';
import { IERC3156FlashLender__factory } from './typechain/IERC3156FlashLender__factory';
export class IERC3156FlashLenderService extends BaseService {
    constructor(provider) {
        super(provider, IERC3156FlashLender__factory);
        this.getFee = this.getFee.bind(this);
        this.contractInterface = IERC3156FlashLender__factory.createInterface();
    }
    getFee(lender, token, amount) {
        const contract = this.getContractInstance(lender);
        return contract.flashFee(token, amount);
    }
}
//# sourceMappingURL=index.js.map